import dayjs from 'dayjs';

/**
 * Pure utility functions extracted from List component
 */

/**
 * Formats timestamp for display in the data grid
 */
export const formatTimestamp = (timestamp: string): string => {
  return dayjs(timestamp).format('DD/MM/YYYY HH:mm:ss');
};

/**
 * Gets color for action chip based on action type (from List.tsx column definition)
 */
export const getActionChipColor = (
  action: string,
): 'success' | 'error' | 'warning' | 'default' => {
  if (action.includes('CREATE')) return 'success';
  if (action.includes('DELETE') || action.includes('UNPUBLISH')) return 'error';
  if (action.includes('UPDATE')) return 'warning';
  return 'default';
};

/**
 * Formats resource ID for display (truncate long IDs)
 */
export const formatResourceId = (
  resourceId: string | null | undefined,
): string => {
  if (!resourceId) return 'N/A';
  return resourceId.slice(0, 8) + '...';
};

/**
 * Formats IP address for display (fallback to N/A)
 */
export const formatIpAddress = (
  ipAddress: string | null | undefined,
): string => {
  return ipAddress || 'N/A';
};

/**
 * Formats details JSON for display (truncate and add ellipsis)
 */
export const formatDetailsForDisplay = (details: unknown): string => {
  if (!details) return 'N/A';
  return JSON.stringify(details).slice(0, 50) + '...';
};

/**
 * Formats details JSON for tooltip (full formatted JSON)
 */
export const formatDetailsForTooltip = (details: unknown): string => {
  return JSON.stringify(details, null, 2);
};

/**
 * Builds the navigation URL for viewing resource history
 */
export const buildResourceHistoryUrl = (resourceId: string): string => {
  return `/audit-logs?resourceId=${resourceId}`;
};
